interface ListeCommuneJson {
  communeCodeInsee: number;
  communeAdresseCom: any;
  communeAdresse: any;
  communeCodePostal: number;
  communeLib: string;
}

export class ListeCommune {
  communeCodeInsee: number;
  communeAdresseCom: any;
  communeAdresse: any;
  communeCodePostal: number;
  communeLib: string;

  constructor(input: ListeCommuneJson) {
    this.communeCodeInsee = input.communeCodeInsee;
    this.communeAdresseCom = input.communeAdresseCom;
    this.communeAdresse = input.communeAdresse;
    this.communeCodePostal = input.communeCodePostal;
    this.communeLib = input.communeLib;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/liste-commune.model.ts